module.exports = __webpack_public_path__ + "static/media/view3.f2eb88be.jpg";